import { render, staticRenderFns } from "./Prodotti.vue?vue&type=template&id=cb2f9b96&scoped=true"
import script from "./Prodotti.vue?vue&type=script&lang=js"
export * from "./Prodotti.vue?vue&type=script&lang=js"
import style0 from "./Prodotti.vue?vue&type=style&index=0&id=cb2f9b96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2f9b96",
  null
  
)

export default component.exports